import React from 'react';
import { Container } from './ErrorPage.styles';

const ErrorPage = () => (
  <Container>
    <h2>Oops!</h2>
    <p>
      An error has occurred. Please refresh the page and cross your fingers.
    </p>
  </Container>
);

export default ErrorPage;
